import { Deserializable } from '../protocols/deserializable';
import { VariableBenefitConfigurationSubmissionData } from './variable-benefit-configuration-submission-data';

export class VariableBenefitConfigurationSubmission implements Deserializable {
  public new!: VariableBenefitConfigurationSubmissionData;

  public onDeserialize(): void {
    if (this.new) {
      this.new = window.injector.Deserialize.instanceOf(VariableBenefitConfigurationSubmissionData, this.new);
    }
  }
}
